import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Import Page Components
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ResourcesPage from "./pages/ResourcesPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import AddResourcePage from "./pages/AddResourcePage";
import EditResourcePage from "./pages/EditResourcePage";
import ManageCategoriesPage from "./pages/ManageCategoriesPage";

// Import Layout/Route Components
import LoggedInLayout from "./components/LoggedInLayout";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* --- Public Routes --- */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* --- Protected Routes --- */}
          {/* All routes that need the logged-in layout are now grouped under this single parent. */}
          <Route
            element={
              <ProtectedRoute>
                <LoggedInLayout />
              </ProtectedRoute>
            }
          >
            {/* Standard user routes */}
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/add-resources" element={<AddResourcePage />} />
            <Route path="/edit-resource/:id" element={<EditResourcePage />} />
            
            {/* Admin-only route */}
            {/* The admin protection is now applied directly to the specific route element. */}
            <Route 
              path="/manage-categories" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <ManageCategoriesPage />
                </ProtectedRoute>
              } 
            />
          </Route>
          
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

